import { AppType } from './app';
import { ClientRequestOptions, hc } from 'hono/client';
import { GetEventsAppType } from './routes/events/getEvents';

const getClient = (options?: ClientRequestOptions) =>
  hc<AppType>(
    process.env.NEXT_PUBLIC_SERVER_BASE_URL || 'http://localhost:3001',
    options
  );

const getEventsClient = (options?: ClientRequestOptions) =>
  hc<GetEventsAppType>(
    process.env.NEXT_PUBLIC_SERVER_GET_EVENTS_BASE_URL ||
      'http://localhost:3001/api/v1.0/events',
    options
  );

export { getClient, getEventsClient };
